<template>
  <v-container
    id="comercial-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-row>
      <v-col
        cols="12"
        class="container"
      >
        <dashboard-filtro-datas
          :primeiro="enablePrimeiroDia"
          :ultimo="enableUltimoDia"
          :empresas="enableEmpresa"
          :receitas="enableReceita"
          :redes="enableRede"
          :categorias="enableCategoria"
          :promotores="enablePromotor"
          :vendedores="enableVendedor"
          :url="link"
        />
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
                <v-card
                  id="cardDashbord"
                  class="mx-auto ma-0 pa-0"
                  outlined
                >
                  <div class="card-header-dashbord">
                    <v-row>
                      <v-col
                        cols="12"
                        sm="10"
                        md="10"
                        lg="10"
                        class="d-flex flex-wrap"
                      >
                        Localização dos pedidos em aberto
                      </v-col>
                    </v-row>
                  </div>
                  <v-card-actions>
                    <v-row>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        lg="12"
                      >
                        <dashboard-table-pedidos />
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
            <v-card
              id="cardDashbord"
              class="mx-auto"
              outlined
            >
              <div class="card-header-dashbord">
                <v-row>
                  <v-col
                    cols="12"
                    sm="10"
                    md="10"
                    lg="10"
                    class="d-flex flex-wrap"
                  >
                    Status dos pedidos em aberto dia a dia
                  </v-col>
                  <v-col
                    cols="12"
                    sm="2"
                    md="2"
                    lg="2"
                    class="d-flex justify-end"
                  >
                    <v-tooltip
                      top
                      max-width="400"
                      width="400"
                    >
                      <template
                        v-slot:activator="{ on, attrs }"
                      >
                        <v-icon
                          id="iconInformationAcumuladoAnualPedido"
                          class="text-left"
                          v-bind="attrs"
                          v-on="on"
                          @mouseover="enableTexto('152')"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <div
                        v-if="carregandoTooltip"
                        class="d-flex align-center"
                      >
                        <v-progress-circular
                          indeterminate
                          size="18"
                          width="2"
                          class="mr-2"
                        />
                        Carregando Orientação...
                      </div>
                      <div
                        v-if="codigo === '152' && !carregandoTooltip"
                        v-html="textoOrientacao"
                      />
                    </v-tooltip>
                  </v-col>
                </v-row>
              </div>
              <v-card-actions>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                  >
                    <dashboard-pedidos-dia-a-dia />
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <v-card
              id="cardDashbord"
              class="mx-auto ma-0 pa-0"
              outlined
            >
              <div class="card-header-dashbord">
                <v-row>
                  <v-col
                    cols="12"
                    sm="10"
                    md="10"
                    lg="10"
                    class="d-flex flex-wrap"
                  >
                    Status dos pedidos em aberto por mês
                  </v-col>
                  <v-col
                    cols="12"
                    sm="2"
                    md="2"
                    lg="2"
                    class="d-flex justify-end"
                  >
                    <v-tooltip
                      top
                      max-width="400"
                      width="400"
                    >
                      <template
                        v-slot:activator="{ on, attrs }"
                      >
                        <v-icon
                          id="iconInformationAcumuladoAnualPedido"
                          class="text-left"
                          v-bind="attrs"
                          v-on="on"
                          @mouseover="enableTexto('153')"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <div
                        v-if="carregandoTooltip"
                        class="d-flex align-center"
                      >
                        <v-progress-circular
                          indeterminate
                          size="18"
                          width="2"
                          class="mr-2"
                        />
                        Carregando Orientação...
                      </div>
                      <div
                        v-if="!carregandoTooltip"
                        v-html="textoOrientacao"
                      />
                      <div
                        v-if="codigo === '153' && !carregandoTooltip"
                        v-html="textoOrientacao"
                      />
                    </v-tooltip>
                  </v-col>
                </v-row>
              </div>
              <v-card-actions>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                  >
                    <dashboard-pedidos-no-mes />
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import utils from '../../../../services/utils'
  import Permissao from '../../../../services/menu'
  import eventEmit from '../../components/core/EventoEmit'

  export default {
    name: 'PageComercial',
    emits: ['updatePedidos', 'disableLoading', 'disableLoadingGrafico', 'atualizarTexto'],
    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
      DashboardFiltroDatas: () => import('../../components/core/FiltroDatas'),
      DashboardPedidosDiaADia: () => import('../../graficos/Pedidos/PedidosDiaAdia'),
      DashboardPedidosNoMes: () => import('../../graficos/Pedidos/PedidosNoMes'),
      DashboardTablePedidos: () => import('../../components/comercial/TablePedidos'),
    },
    mixins: [utils],
    data: () => ({
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObject: {
        color: localStorage.corPrimaria,
      },
      usuarioIdentificado: false,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      date: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      dateFormatted: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      select: [],
      empresa: [],
      receita: [],
      rede: [],
      categoria: [],
      promotor: [],
      vendedor: [],
      textoPedidoDia: '',
      textoPedidoMes: '',
      codigo: 0,
      orientacao: [],
      codigoIds: ['152', '153'],
      paginaEnable: false,
      permissaoPedidos: '',
      enablePrimeiroDia: true,
      enableUltimoDia: true,
      enableEmpresa: true,
      enableReceita: true,
      enableRede: true,
      enableCategoria: true,
      enablePromotor: true,
      enableVendedor: true,
      link: window.location.href,
      chartPedidoDiaADia: {},
      datasetsDiaADia: [],
      statusDiaaDia: [],
      headersClients: [
        { text: 'Num. Pedido', value: 'pedido', align: 'left', class: 'black--text title' },
        { text: 'Cliente', value: 'cliente', align: 'left', class: 'black--text title' },
        { text: 'Vendedor', value: 'vendedor', align: 'left', class: 'black--text title' },
        { text: 'Data', value: 'periodo', align: 'left', class: 'black--text title' },
        { text: 'Valor', value: 'valor', align: 'right', class: 'black--text title' },
      ],
      clientsDia: [],
      dynamicPaddingPedidos: '',
      textoOrientacao: '',
      carregandoTooltip: false,
      codigoAtual: null,
    }),

    watch: {
      date (val) {
        this.dateFormatted = this.formatDate(this.date)
      },
    },

    created () {
      eventEmit.$on('update-dados', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados', this.handleUpdateDados)

      window.removeEventListener('resize', this.updateDynamicPadding)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        eventEmit.$emit('atualizar_texto', 'Pedidos Vendas')

        this.updateDynamicPadding()

        window.addEventListener('resize', this.updateDynamicPadding)

        this.usuarioIdentificado = true
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        this.$router.push('/login')
      }
    },

    methods: {
      updateDynamicPadding () {
        if (window.innerWidth > 1800) {
          this.dynamicPaddingPedidos = 'padding-right: 104rem !important'
        } else if (window.innerWidth > 1380 && window.innerWidth <= 1800) {
          this.dynamicPaddingPedidos = 'padding-right: 60rem !important'
        } else if (window.innerWidth > 380 && window.innerWidth < 650) {
          this.dynamicPaddingPedidos = 'padding-right: 10rem !important'
        } else if (window.innerWidth > 651 && window.innerWidth < 1000) {
          this.dynamicPaddingPedidos = 'padding-right: 25rem !important'
        } else {
          this.dynamicPaddingPedidos = 'padding-right: 58rem !important'
        }
      },

      handleUpdateDados (primeiroDia, dataFinal, select, vendedor, area, rede, supervisor, receita, segmento, classificacao, produto, cidade, categoria, promotor) {
        this.primeiroDia = primeiroDia
        this.date = dataFinal
        this.select = select
        this.receita = receita
        this.rede = rede
        this.categoria = categoria
        this.promotor = promotor
        this.vendedor = vendedor

        localStorage.setItem('updateDadosFiltros', true)
        localStorage.setItem('dataInicial', this.primeiroDia)
        localStorage.setItem('dataFinal', this.date)

        this.updateDate()
      },

      async enableTexto (value) {
        if (this.codigoAtual === value && this.textoOrientacao) return

        this.codigoAtual = value
        this.carregandoTooltip = true
        this.textoOrientacao = ''

        try {
          const resposta = await Permissao.showOrientacaoIndicador(localStorage.username, localStorage.tokencontrato, value)

          if (resposta.data.status) {
            this.textoOrientacao = resposta.data.orientacao
            this.codigo = value
          }
        } catch (e) {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        } finally {
          this.carregandoTooltip = false
        }
      },

      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },

      async updateDate () {
        eventEmit.$emit('update-pedidos', this.primeiroDia, this.date, this.select, this.receita, this.rede, this.categoria, this.promotor, this.vendedor)
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style scoped>
  #cardDashbord {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    transform: translateY(-3px);
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }

  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 560px) {
    /* #btnRefazerVendas {
      font-size: 10px;
      margin-top: 2rem;
      margin-left: -1.4rem;
    } */

    #divisao1 {
      width: 90%;
    }

    #statusDiaADiaPedido {
      margin: -2rem 0 0 0;
    }

    #statusUltimosMesesPedido {
      margin: 7rem 0 0 0;
    }

    #iconInformationAcumuladoAnualPedido {
      margin: -5rem 0 0 -2rem;
    }

    #dashboard-core-footer {
      margin: 5rem 0 0 0 !important;
    }

    #pedidos-form {
      margin-bottom: 10rem;
    }
  }

  @media screen
  and (min-width : 481px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #statusDiaADiaPedido {
      margin: auto;
    }

    #statusUltimosMesesPedido {
      margin: auto;
    }

    #iconInformationAcumuladoAnualPedido {
      margin: auto;
    }
  }
</style>

<style lang="sass">
  #statusDiaADiaPedido
    margin: auto

  #statusUltimosMesesPedido
    margin: auto

  #iconInformationAcumuladoAnualPedido
    margin: 0 0 0 4rem

  #pedidos-form
    margin-top: 1rem

  .highlighted-item
    background-color: #2863af
    padding: 16px
    color: white
    margin: -1rem 0 0 0

  #listItemPedidos
    margin: -2rem 0 0 -1rem

</style>
